import { css } from "@emotion/react";

import PcBentoContents from "~/components/me/bento/PcBentoContents";

const PcPage = () => {
  return (
    <main css={mainStyle}>
      <PcBentoContents />
    </main>
  );
};

const mainStyle = css`
  margin: 2rem auto;
`;

export default PcPage;
